import DocumentationTopics from './DocumentationTopics.vue';
import DocumentationTopic from './DocumentationTopic.vue';
import DocumentationDownload from './DocumentationDownload.vue';

export default function DocumentationRoutes() {
  return [
    {
      path: '',
      redirect: { name: 'documentationTopics' }
    },
    {
      path: 'topics',
      component: DocumentationTopics,
      name: 'documentationTopics'
    },
    {
      path: 'topic',
      component: DocumentationTopic,
      name: 'documentationTopic'
    },
    {
      path: 'download',
      component: DocumentationDownload,
      name: 'downloadDocumentationFile'
    }
  ]
}
